import { GQL_ID, Slot } from '@@types'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { GQL_AVAILABLE_SLOTS } from '../api/graphql'


interface AvailableSlotsQuery {
  availableSlots: Slot[]
}

interface AvailableSlotsVariables {
  shopId?: GQL_ID
  zoneId?: GQL_ID
}

interface UseAvailableSlotsProps {
  shopId?: GQL_ID | null
  zoneId?: GQL_ID | null
  pollInterval?: number
  skip?: boolean
}

/**
 * Хук для получения доступных слотов
 * Аналог useFetchShopAvailableSlots из приложения
 */
export function useAvailableSlots ({
  shopId,
  zoneId,
  pollInterval,
  skip: externalSkip = false,
}: UseAvailableSlotsProps) {
  const hasValidId = Boolean(shopId || zoneId)
  const skip = externalSkip || !hasValidId

  const { data, loading, error, refetch } = useQuery<
    AvailableSlotsQuery,
    AvailableSlotsVariables
  >(GQL_AVAILABLE_SLOTS, {
    variables: {
      shopId: shopId ?? undefined,
      zoneId: zoneId ?? undefined,
    },
    skip,
    fetchPolicy: 'no-cache',
    pollInterval,
  })

  // Фильтруем истекшие слоты как в приложении
  const slots: Slot[] = useMemo(() => {
    if (data?.availableSlots && data.availableSlots.length > 0) {
      const now = Date.now()
      return data.availableSlots.filter(
        (slot) => parseInt(slot.availableUntil) > now
      )
    }
    return []
  }, [ data ])

  return {
    slots,
    data,
    loading,
    error,
    refetch,
  }
}
